<template>
  <report-layout>
    <div id="report">
      <div class="d-flex justify-content-between align-fields-center mb-4">
        <div class="d-flex">
          <button type="button" class="btn btn-primary mr-4" @click="goBack()">
            <i class="tio-chevron-left"></i>
          </button>
          <img src="/images/icona_immobile.svg" class="mr-2" style="width: 3.125rem" />
          <div>
            <h3 class="text-primary font-weight-bold mb-1">Perizia</h3>
            <div>{{ address }}</div>
          </div>
        </div>
        <div class="d-flex">
          <label class="toggle-switch d-flex align-items-center mr-3" for="status-switch">
            <input type="checkbox" class="toggle-switch-input" id="status-switch" v-model="report.status" />
            <span class="toggle-switch-label">
              <span class="toggle-switch-indicator"></span>
            </span>
            <span class="toggle-switch-content">
              <span v-if="report.status" class="d-block">Conclusa</span>
              <span v-else class="d-block">Bozza</span>
            </span>
          </label>

          <button class="btn btn-primary" @click="toggleMenu(true)"><i class="tio-menu-left-right"></i></button>
        </div>
      </div>

      <!-- report menu -->
      <div id="report-menu" :class="{ open: showMenu }">
        <div class="close-button" @click="toggleMenu(false)"><i class="tio-clear"></i></div>
        <div
          v-for="category in report.categories"
          :key="`tab-${category.key}`"
          class="card card-pill text-center mb-3 w-100 justify-content-center"
          :class="{ active: category.key == activeCategory }"
          @click="changeCategory(category.key)"
        >
          <span>{{ category.name }}</span>
        </div>
      </div>

      <!-- dynamic sections generation -->
      <div id="report-content" class="mb-4">
        <template v-for="category in report.categories">
          <transition name="fade" :key="`content-${category.key}`">
            <div v-show="category.key == activeCategory" class="report-category">
              <div v-for="(section, sectionIndex) in category.sections" class="card py-4 px-5 mb-5" :key="`section-${category.key}-${sectionIndex}`">
                <div class="card-header px-0 pt-2 pb-4 d-flex justify-content-between align-fields-center">
                  <div class="text-primary" style="font-size: 18px; font-weight: 500">{{ section.title }}</div>
                  <button v-if="section.sectionType == 'multiple'" class="btn btn-outline-primary" @click="showFormModal(sectionIndex)">Aggiungi</button>
                </div>
                <div class="card-body p-0 py-4">
                  <!-- section type: SINGLE -->
                  <template v-if="section.sectionType == 'single'">
                    <!-- groups -->
                    <template v-for="(group, groupIndex) in section.form">
                      <div v-if="checkGroupShow(report.categories, group)" class="form-group report-group row" :key="`group-${category.key}-${sectionIndex}-${groupIndex}`">
                        <!-- fields -->
                        <template v-for="(field, fieldIndex) in group.fields">
                          <component
                            v-show="checkFieldShow(report.categories, field)"
                            :disabled="checkFieldDisable(report.categories, field)"
                            :is="`report-${field.type}`"
                            v-bind="field"
                            v-model="field.value"
                            :items.sync="field.items"
                            :unique-key="`${category.key}-${sectionIndex}-${groupIndex}`"
                            :key="`field-${category.key}-${sectionIndex}-${groupIndex}-${fieldIndex}`"
                            class="report-field"
                            @input="handleComponentInput(field, section.form)"
                          ></component>
                        </template>
                        <!-- end fields -->
                      </div>
                    </template>
                    <!-- end groups -->
                  </template>
                  <!-- end section type: SINGLE -->

                  <!-- section type: MULTIPLE -->
                  <template v-if="section.sectionType == 'multiple'">
                    <!-- form modal -->
                    <report-form-modal :categoryKey="category.key" :sectionIndex="sectionIndex" :sectionTitle="section.title" :locked="formLocked" @submit="saveSectionItem">
                      <!-- groups -->
                      <template v-for="(group, groupIndex) in section.form">
                        <div v-if="checkGroupShow(report.categories, group, section.form)" class="form-group report-group row" :key="`group-${category.key}-${sectionIndex}-${groupIndex}`">
                          <!-- fields -->
                          <template v-for="(field, fieldIndex) in group.fields">
                            <component
                              v-if="checkFieldShow(report.categories, field, section.form)"
                              :disabled="checkFieldDisable(report.categories, field, section.form)"
                              :is="`report-${field.type}`"
                              v-bind="field"
                              v-model="field.value"
                              :items.sync="field.items"
                              :unique-key="`${category.key}-${sectionIndex}-${groupIndex}`"
                              :key="`field-${category.key}-${sectionIndex}-${groupIndex}-${fieldIndex}`"
                              class="report-field"
                              v-on:formlock="(lock) => (formLocked = lock)"
                              @input="handleComponentInput(field, section.form)"
                            ></component>
                          </template>
                          <!-- end fields -->
                        </div>
                      </template>
                      <!-- end groups -->
                    </report-form-modal>
                    <!-- end form modal -->

                    <!-- delete modal -->
                    <report-delete-modal :categoryKey="category.key" :sectionIndex="sectionIndex" :sectionTitle="section.title" @submit="deleteSectionItem"> </report-delete-modal>
                    <!-- end delete modal -->

                    <!-- index table -->
                    <template v-if="'index_table' in section">
                      <report-index-table :section="section" @action="(action, itemIndex) => handleIndexTableAction(action, sectionIndex, itemIndex)"></report-index-table>
                    </template>
                    <!-- end index table -->
                  </template>
                  <!-- end section type: MULTIPLE -->
                </div>
              </div>
            </div>
          </transition>
        </template>
      </div>

      <!-- save button -->
      <div class="d-flex justify-content-end mb-5">
        <button class="btn btn-primary" :disabled="isSaving" @click="save">
          <span v-if="isSaving" class="mr-2">
            <div class="spinner-border text-light" style="height: 1rem; width: 1rem; border-width: 0.15em" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </span>
          <span>Salva perizia</span>
        </button>
      </div>
    </div>
  </report-layout>
</template>

<script>
import ReportLayout from "@/Layouts/ReportLayout";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ReportCollection from "@/Pages/Admin/Properties/Report/Partials/ReportCollection";
import ReportCurrency from "@/Pages/Admin/Properties/Report/Partials/ReportCurrency";
import ReportDeleteModal from "@/Pages/Admin/Properties/Report/Partials/ReportDeleteModal";
import ReportFiles from "@/Pages/Admin/Properties/Report/Partials/ReportFiles";
import ReportFlag from "@/Pages/Admin/Properties/Report/Partials/ReportFlag";
import ReportFormModal from "@/Pages/Admin/Properties/Report/Partials/ReportFormModal";
import ReportIndexTable from "@/Pages/Admin/Properties/Report/Partials/ReportIndexTable";
import ReportNumber from "@/Pages/Admin/Properties/Report/Partials/ReportNumber";
import ReportSelect from "@/Pages/Admin/Properties/Report/Partials/ReportSelect";
import ReportMultiselect from "@/Pages/Admin/Properties/Report/Partials/ReportMultiselect";
import ReportText from "@/Pages/Admin/Properties/Report/Partials/ReportText";
import ReportDate from "@/Pages/Admin/Properties/Report/Partials/ReportDate";
import ReportTextarea from "@/Pages/Admin/Properties/Report/Partials/ReportTextarea";
import { checkGroupShow, checkFieldShow, checkFieldDisable, findFieldByKey, findFieldInFormByKey, checkCondition } from "./helpers";

export default {
  props: ["property", "report", "startCategory"],

  components: {
    ReportLayout,
    vueDropzone,
    ReportCollection,
    ReportCurrency,
    ReportDeleteModal,
    ReportFiles,
    ReportFlag,
    ReportFormModal,
    ReportIndexTable,
    ReportNumber,
    ReportSelect,
    ReportMultiselect,
    ReportText,
    ReportDate,
    ReportTextarea
  },

  data() {
    return {
      activeCategory: "immobile_oggetto_valutazione",
      formLocked: false,
      isSaving: false,
      deletingCoordinates: { sectionIndex: null, itemIndex: null },
      editingCoordinates: { sectionIndex: null, itemIndex: null },
      formResetters: {},
      showMenu: false
    };
  },

  mounted() {
    this.activeCategory = this.startCategory;
  },

  computed: {
    address() {
      return `${this.property.address} ${this.property.house_number}, ${this.property.postal_code} ${this.property.municipality}`;
    }
  },

  methods: {
    checkGroupShow,
    checkFieldShow,
    checkFieldDisable,
    findFieldByKey,
    findFieldInFormByKey,
    checkCondition,

    handleLatoInput(form) {
      const lato_1_field = this.findFieldInFormByKey("lato_1", form);
      const lato_2_field = this.findFieldInFormByKey("lato_2", form);
      const mq_field = this.findFieldInFormByKey("mq", form);
      mq_field.value = parseInt(lato_1_field.value) * parseInt(lato_2_field.value);
    },

    handleComponentInput(field, form) {
      if (field.fieldKey == "lato_1" || field.fieldKey == "lato_2") {
        this.handleLatoInput(form);
      }
    },

    toggleMenu(state) {
      if (state) return (this.showMenu = state);
      return (this.showMenu = !this.showMenu);
    },

    changeCategory(categoryKey) {
      this.activeCategory = categoryKey;
      this.toggleMenu(false);
    },

    findSectionInActiveCategory(sectionIndex) {
      const category = this.report.categories.find(c => c.key == this.activeCategory);
      return category.sections[sectionIndex];
    },

    handleIndexTableAction(action, sectionIndex, itemIndex) {
      switch (action) {
        case "delete":
          this.showDeleteModal(sectionIndex, itemIndex);
          break;

        default:
          this.showFormModal(sectionIndex, itemIndex);
          break;
      }
    },
    showDeleteModal(sectionIndex, itemIndex) {
      this.deletingCoordinates.sectionIndex = sectionIndex;
      this.deletingCoordinates.itemIndex = itemIndex;
      $(`#delete-modal-${this.activeCategory}-${sectionIndex}`).modal();
    },
    showFormModal(sectionIndex, itemIndex = null) {
      const section = this.findSectionInActiveCategory(sectionIndex);
      const resetterKey = `${this.activeCategory}:${sectionIndex}`;
      if (resetterKey in this.formResetters) {
        section.form = _.cloneDeep(this.formResetters[resetterKey]);
      } else {
        this.formResetters[resetterKey] = _.cloneDeep(section.form);
      }

      if (itemIndex != null) section.form = _.cloneDeep(section.items[itemIndex]);

      this.editingCoordinates.sectionIndex = sectionIndex;
      this.editingCoordinates.itemIndex = itemIndex;
      $(`#form-modal-${this.activeCategory}-${sectionIndex}`).attr("data-modal-type", itemIndex == null ? "add" : "edit");
      $(`#form-modal-${this.activeCategory}-${sectionIndex}`).modal();
    },
    saveSectionItem() {
      const sectionIndex = this.editingCoordinates.sectionIndex;
      const itemIndex = this.editingCoordinates.itemIndex;
      const section = this.findSectionInActiveCategory(sectionIndex);
      const resetterKey = `${this.activeCategory}:${sectionIndex}`;

      if (itemIndex != null) section.items[itemIndex] = _.cloneDeep(section.form);
      else section.items.push(_.cloneDeep(section.form));
      section.form = _.cloneDeep(this.formResetters[resetterKey]);

      $(`#form-modal-${this.activeCategory}-${sectionIndex}`).modal("hide");
    },
    deleteSectionItem() {
      const sectionIndex = this.deletingCoordinates.sectionIndex;
      const itemIndex = this.deletingCoordinates.itemIndex;
      const section = this.findSectionInActiveCategory(sectionIndex);

      section.items.splice(itemIndex, 1);

      $(`#delete-modal-${this.activeCategory}-${sectionIndex}`).modal("hide");
    },

    async save() {
      this.isSaving = true;

      await this.$inertia.post(`/admin/properties/${this.property.id}/report`, {
        reportStructure: this.report
      });

      this.isSaving = false;
    },

    goBack() {
      this.$inertia.visit(`/admin/properties/${this.property.id}`);
    }
  }
};
</script>

<style lang="scss">
#report {
  .card-pill {
    cursor: pointer;
    min-height: 3rem;

    &.active {
      background-color: #357d40;
      color: white;
    }
  }

  #report-content {
    position: relative;

    .report-category {
      &.fade-enter-active,
      &.fade-leave-active {
        position: absolute;
        left: 0;
        right: 0;
        transition: opacity 300ms;
      }

      &.fade-enter-active {
        z-index: 20;
      }

      &.fade-leave-active {
        z-index: 10;
      }

      &.fade-enter,
      &.fade-leave-to {
        opacity: 0;
      }

      .report-group {
        margin-bottom: 2.5rem;

        &:last-child {
          margin-bottom: 0;
        }

        .report-field {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          margin-bottom: 1rem;

          label {
            font-size: 0.875rem !important;
          }
        }
      }
    }
  }

  #report-menu {
    position: fixed;
    z-index: 100;
    top: 0;
    bottom: 0;
    right: 0;
    width: 25rem;
    max-width: 100vw;
    background-color: white;
    padding: 6rem 2.5rem;
    padding-bottom: 0;
    overflow-y: auto;
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
    transform: translate(110%);
    transition: all 500ms ease;

    &.open {
      transform: translate(0%);
    }

    .close-button {
      position: absolute;
      top: 1rem;
      right: 1.5rem;
      font-size: 2rem;
      cursor: pointer;
    }
  }
}
</style>
